import { Commit as CommitIcon } from "components/icons/generated";
import { Commit, VcsProvider } from "types/generated";
import { getCommitLabel } from "utils/commit";
import { providerHasVcsHost } from "utils/vcs";

import MetaInfoListItem from "./Item";

type MetaInfoCommitProps = {
  commit: Commit;
  provider: VcsProvider;
  fullWidth?: boolean;
};

const MetaInfoCommit = ({ commit, provider, fullWidth }: MetaInfoCommitProps) => {
  const commitLabel = getCommitLabel(provider, commit.hash);

  // Blob Storage has no VCS host, so the commit points nowhere: render the hash as
  // plain text rather than a dead link.
  if (!providerHasVcsHost(provider)) {
    return (
      <MetaInfoListItem
        icon={CommitIcon}
        tooltip={`Commit set by ${commit.authorName}`}
        type="commit"
        fullWidth={fullWidth}
      >
        {commitLabel}
      </MetaInfoListItem>
    );
  }

  return (
    <MetaInfoListItem
      href={commit.url}
      linkText={commitLabel}
      icon={CommitIcon}
      tooltip={`Commit set by ${commit.authorName}`}
      target="_blank"
      type="commit"
      fullWidth={fullWidth}
    />
  );
};

export default MetaInfoCommit;
